import { memo, type ReactElement } from 'react'

function DateIcon (): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#7F95A0" fillRule="nonzero" transform="translate(-959 -327)">
          <g transform="translate(326 289)">
            <g transform="translate(500 29)">
              <g transform="translate(133.941 9)">
                <path
                  d="M17.616 22H2.443A2.447 2.447 0 010 19.557V4.385A2.447 2.447 0 012.443 1.94h15.173a2.445 2.445 0 012.443 2.444v15.172A2.443 2.443 0 0117.616 22zM2.443 2.94c-.796 0-1.445.648-1.445 1.445v15.172c0 .796.649 1.444 1.445 1.444h15.173c.796 0 1.446-.648 1.446-1.444V4.385c0-.797-.648-1.445-1.446-1.445H2.443z"
                />
                <path
                  d="M5.822 4.53c-.358 0-.646-.232-.646-.515V.514c0-.285.291-.514.646-.514.356 0 .649.231.649.514v3.501c-.003.283-.293.514-.649.514zM14.237 4.53c-.358 0-.649-.232-.649-.515V.514c0-.285.29-.514.649-.514.357 0 .645.231.645.514v3.501c.003.283-.288.514-.645.514zM19.559 7.765H.5c-.276 0-.5-.291-.5-.647 0-.356.224-.647.5-.647H19.56c.276 0 .5.29.5.647 0 .356-.224.647-.5.647z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default memo(DateIcon)
